import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import { createPinia, PiniaVuePlugin } from 'pinia';

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);
export const pinia = createPinia();
